import { photoUrl } from '../lib/photoUrl';
import { priceLabel } from '../lib/format';
import type { PriceLevel } from '@bilmat/shared';

type Props = {
  name: string;
  typeLabel: string;
  priceLevel: PriceLevel | null;
  rating: number | null;
  photoRef: string | null;
  onBack: () => void;
};

export function DetailHero({ name, typeLabel, priceLevel, rating, photoRef, onBack }: Props) {
  const img = photoUrl(photoRef, 1000);
  const sub = [typeLabel, priceLabel(priceLevel)].filter(Boolean).join(' · ');
  return (
    <div className="detail-hero" style={img ? { backgroundImage: `url(${img})` } : undefined}>
      <button type="button" className="hero-back" aria-label="Tillbaka" onClick={onBack}>
        ‹
      </button>
      {rating != null && (
        <span className="hero-rating">
          <span className="hero-rating-star" aria-hidden>
            ★
          </span>
          {rating.toFixed(1)}
        </span>
      )}
      <div className="hero-gradient" />
      <div className="hero-text">
        <h1 className="hero-title">{name}</h1>
        <span className="hero-sub">{sub}</span>
      </div>
    </div>
  );
}
